// extracted by mini-css-extract-plugin
export default {"shrink":"Main_shrink__YuqL3","content":"Main_content__+BAXg","left":"Main_left__9KcEE","right":"Main_right__QGO11"};